import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Banner } from './components/Banner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { NavBar } from './components/NavBar';
import { Projects } from './components/Projects';
import { Skills } from './components/Skills';
import { Formation } from './components/Formation';

function App() {
  return (
    <div>
      <ToastContainer position="bottom-center" />
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <Formation />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
